/* PDFCommunity - cookie consent for Google Analytics (v37, links updated in v46,
   shorter banner text in v55 so the banner stays small on phones).
   Google Analytics (gtag.js) is only loaded after the visitor clicks
   "Accept" in this banner. Declining - or not choosing - means Google is
   never contacted and no Google cookies are set. The choice itself is kept
   in this browser's localStorage (not a cookie) and can be changed at any
   time via "Cookie settings" in the footer. The loader in each page's
   <head> (window.pdfcLoadGA) starts Google Analytics straight away on
   later page views once consent was given. */
(function(){
  'use strict';
  var KEY = 'pdfc-consent';
  var LANG = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2);
  // (v57) the banner's link says where it goes ("Privacy policy"), not
  // "More info": a link text that makes sense on its own (WCAG 2.4.4)
  var T = {
    en: { text: 'We only use Google Analytics cookies with your consent, to improve the site.', accept: 'Accept', decline: 'Decline', more: 'Privacy policy', settings: 'Cookie settings', label: 'Cookie consent' },
    nl: { text: 'We gebruiken Google Analytics-cookies alleen met je toestemming, om de site te verbeteren.', accept: 'Accepteren', decline: 'Weigeren', more: 'Privacybeleid', settings: 'Cookie-instellingen', label: 'Toestemming voor cookies' },
    fr: { text: 'Nous n\'utilisons les cookies Google Analytics qu\'avec votre accord, pour améliorer le site.', accept: 'Accepter', decline: 'Refuser', more: 'Politique de confidentialité', settings: 'Paramètres des cookies', label: 'Consentement aux cookies' },
    de: { text: 'Google-Analytics-Cookies setzen wir nur mit Ihrer Einwilligung, um die Seite zu verbessern.', accept: 'Akzeptieren', decline: 'Ablehnen', more: 'Datenschutzerklärung', settings: 'Cookie-Einstellungen', label: 'Cookie-Einwilligung' },
    es: { text: 'Solo usamos cookies de Google Analytics con tu consentimiento, para mejorar el sitio.', accept: 'Aceptar', decline: 'Rechazar', more: 'Política de privacidad', settings: 'Configuración de cookies', label: 'Consentimiento de cookies' },
    pt: { text: 'Só usamos cookies do Google Analytics com o seu consentimento, para melhorar o site.', accept: 'Aceitar', decline: 'Recusar', more: 'Política de privacidade', settings: 'Configurações de cookies', label: 'Consentimento de cookies' }, it: { text: "Usiamo i cookie di Google Analytics solo con il tuo consenso, per migliorare il sito.", accept: "Accetta", decline: "Rifiuta", more: "Informativa sulla privacy", settings: "Impostazioni cookie", label: "Consenso ai cookie" }, pl: { text: "Plików cookie Google Analytics używamy tylko za Twoją zgodą, żeby ulepszać serwis.", accept: "Akceptuj", decline: "Odrzuć", more: "Polityka prywatności", settings: "Ustawienia plików cookie", label: "Zgoda na pliki cookie" }
  }[LANG] || null;
  if(!T) return;
  // v46: own pages for the privacy policy and the terms of use
  var PAGES = {
    en: { privacy: '/privacy.html', terms: '/terms.html' },
    nl: { privacy: '/nl/privacy.html', terms: '/nl/gebruiksvoorwaarden.html' },
    fr: { privacy: '/fr/confidentialite.html', terms: '/fr/conditions-utilisation.html' },
    de: { privacy: '/de/datenschutz.html', terms: '/de/nutzungsbedingungen.html' },
    es: { privacy: '/es/privacidad.html', terms: '/es/condiciones-de-uso.html' },
    pt: { privacy: '/pt/privacidade.html', terms: '/pt/termos-de-uso.html' }, it: { privacy: "/it/privacy.html", terms: "/it/termini-di-utilizzo.html" }, pl: { privacy: "/pl/polityka-prywatnosci.html", terms: "/pl/regulamin.html" }
  }[LANG];

  // (v55) a choice holds for 12 months, then the banner asks again (the
  // page's inline loader applies the same limit before starting Analytics)
  var KEY_AT = 'pdfc-consent-at', MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;
  function get(){
    try{
      var v = localStorage.getItem(KEY);
      // a choice made before v55 has no date yet: it counts from now on
      if(v && localStorage.getItem(KEY_AT) === null) localStorage.setItem(KEY_AT, String(Date.now()));
      if(v && !(Date.now() - Number(localStorage.getItem(KEY_AT)) < MAX_AGE_MS)) return null;
      return v;
    }catch(e){ return null; }
  }
  function set(v){ try{ localStorage.setItem(KEY, v); localStorage.setItem(KEY_AT, String(Date.now())); }catch(e){ /* storage blocked: the choice holds for this visit only */ } }

  // Removes Google Analytics cookies after a "Decline" (e.g. when consent
  // given earlier is withdrawn via Cookie settings).
  function clearGaCookies(){
    var host = location.hostname, parts = host.split('.');
    var domains = ['', host, '.' + host];
    if(parts.length > 2) domains.push('.' + parts.slice(-2).join('.'));
    document.cookie.split(';').forEach(function(c){
      var name = c.split('=')[0].trim();
      if(name === '_ga' || name.indexOf('_ga_') === 0 || name === '_gid' || name === '_gat'){
        domains.forEach(function(d){
          document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' + (d ? '; domain=' + d : '');
        });
      }
    });
  }

  // Opens the (normally hidden) privacy policy / terms section. Also used
  // when a page is opened with #privacybeleid or #voorwaarden in the URL.
  function openLegal(id){
    var target = document.getElementById(id);
    if(!target || !target.classList.contains('legal-page')) return;
    var open = document.querySelectorAll('.legal-page.show');
    for(var i = 0; i < open.length; i++) if(open[i] !== target) open[i].classList.remove('show');
    target.classList.add('show');
    if(location.hash !== '#' + id){ try{ history.replaceState(null, '', '#' + id); }catch(e){ /* address bar not updated; nothing else depends on it */ } }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block:'start'});
  }
  function openFromHash(){
    var id = location.hash.slice(1);
    if(id !== 'privacybeleid' && id !== 'voorwaarden') return;
    // v46: the policy and terms have their own pages; old links still work
    if(document.getElementById(id)) openLegal(id);
    else location.replace(id === 'privacybeleid' ? PAGES.privacy : PAGES.terms);
  }

  /* (v49) accessibility: the banner is a labelled region placed right after
     the skip link, so keyboard users reach it within a few Tabs (it still
     shows fixed at the bottom). While it is shown, the page keeps focused
     elements clear of it (scroll-padding, extra room below the footer and
     a scroll when a covered element gets focus). Esc closes it: on a first visit
     that is the same as "Decline" (nothing is loaded); when it was opened
     again via "Cookie settings", Esc keeps the choice already made. After a
     choice made from inside the banner, focus goes to the tool (or the main
     content) instead of being lost. */
  var SCROLL_GAP_PX = 16;
  var banner = null;
  var bannerSize = null; // (v59) ResizeObserver on the banner, see show()
  function clearPad(){
    document.documentElement.style.scrollPaddingBottom = '';
    document.documentElement.style.paddingBottom = '';
  }
  function padForBanner(){
    if(!banner) return;
    var r = banner.getBoundingClientRect();
    // (v155) hidden by the visitor's browser (a cookie-banner blocker sets display:none):
    // a 0x0 box gave a scroll padding of a whole screen, so every focused button
    // jumped the page between mouse-down and mouse-up and the click was lost
    if(!r.height){ clearPad(); return; }
    var px = Math.ceil(window.innerHeight - r.top + SCROLL_GAP_PX) + 'px';
    document.documentElement.style.scrollPaddingBottom = px;
    // room below the footer, so its last links can scroll clear of the banner too
    document.documentElement.style.paddingBottom = px;
  }
  // Browsers do not scroll an element that is already "in view" when it
  // gets focus, even if the fixed banner covers it: move it up ourselves.
  function keepFocusClear(e){
    if(!banner || !e.target || !e.target.getBoundingClientRect || banner.contains(e.target)) return;
    var r = e.target.getBoundingClientRect(), z = banner.getBoundingClientRect();
    if(!z.height) return; // (v155) banner hidden by the browser: nothing to keep clear of
    if(r.bottom <= z.top - SCROLL_GAP_PX || r.top >= z.bottom) return;
    var html = document.documentElement, was = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto'; // jump, like the browser's own focus scrolling
    window.scrollBy(0, r.bottom - z.top + SCROLL_GAP_PX);
    html.style.scrollBehavior = was;
  }
  // (v49) the element that reopened the banner ("Cookie settings" in the
  // footer): focus goes into the banner, and back to it afterwards
  var opener = null;
  function focusAfterChoice(){
    if(opener && document.contains(opener)){ var o = opener; opener = null; o.focus(); return; }
    opener = null;
    var target = document.getElementById('tool') || document.querySelector('main') || document.querySelector('h1');
    if(!target) return;
    if(!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({preventScroll: true});
  }
  function onKey(e){
    if(e.key !== 'Escape' || e.defaultPrevented || !banner) return;
    var hadFocus = banner.contains(document.activeElement);
    // Esc belongs to the banner only when the visitor is in it (or nowhere
    // in particular) -- not while typing in a field of a tool
    var ae = document.activeElement;
    if(!hadFocus && ae && ae !== document.body && (/^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName) || ae.isContentEditable)) return;
    if(get() === 'granted' || get() === 'denied') hide();
    else { decline(); hide(); } // (v142) same as the Decline button, also stops a running Analytics
    if(hadFocus) focusAfterChoice();
  }
  // (v140) decided on whether Analytics runs on this page, not on the
  // stored choice: with blocked storage that choice reads as empty.
  // Stopped on the spot; no reload, so a tool's work is never lost.
  function decline(){
    set('denied');
    if(window.pdfcStopGA) window.pdfcStopGA();
    clearGaCookies();
  }
  function hide(){
    if(!banner) return;
    banner.remove(); banner = null;
    clearPad();
    window.removeEventListener('resize', padForBanner);
    if(bannerSize){ bannerSize.disconnect(); bannerSize = null; }
    document.removeEventListener('focusin', keepFocusClear);
    document.removeEventListener('keydown', onKey);
  }
  function show(){
    if(banner) return;
    banner = document.createElement('div');
    banner.className = 'consent-banner';
    banner.setAttribute('role', 'region');
    banner.setAttribute('aria-label', T.label);
    var p = document.createElement('p');
    p.textContent = T.text + ' ';
    var a = document.createElement('a');
    a.href = PAGES.privacy;
    a.textContent = T.more;
    p.appendChild(a);
    var btns = document.createElement('div');
    btns.className = 'consent-buttons';
    var no = document.createElement('button');
    no.type = 'button'; no.className = 'btn consent-decline'; no.textContent = T.decline;
    var yes = document.createElement('button');
    yes.type = 'button'; yes.className = 'btn consent-accept'; yes.textContent = T.accept;
    no.addEventListener('click', function(){
      var hadFocus = banner.contains(document.activeElement);
      decline();
      hide();
      if(hadFocus) focusAfterChoice();
    });
    yes.addEventListener('click', function(){
      var hadFocus = banner.contains(document.activeElement);
      set('granted');
      hide();
      if(hadFocus) focusAfterChoice();
      if(window.pdfcLoadGA) window.pdfcLoadGA();
    });
    btns.appendChild(no);
    btns.appendChild(yes);
    banner.appendChild(p);
    banner.appendChild(btns);
    var skip = document.querySelector('body > .skip-link');
    if(skip) skip.insertAdjacentElement('afterend', banner);
    else document.body.prepend(banner);
    // (v59) measured once the browser has laid the banner out anyway (a
    // ResizeObserver runs right after layout), instead of forcing an extra
    // layout straight after inserting it; also follows the banner when its
    // text wraps differently (rotation, zoom)
    if(window.ResizeObserver){ bannerSize = new ResizeObserver(padForBanner); bannerSize.observe(banner); }
    else requestAnimationFrame(padForBanner);
    window.addEventListener('resize', padForBanner);
    document.addEventListener('focusin', keepFocusClear);
    document.addEventListener('keydown', onKey);
  }

  function openFrom(el){
    show();
    opener = el;
    var first = banner && banner.querySelector('button');
    if(first) first.focus();
  }
  function addFooterLink(){
    // v46: the footer already has a "Cookie settings" link; only wire it up
    var ready = document.querySelectorAll('footer a.consent-settings');
    if(ready.length){
      for(var i = 0; i < ready.length; i++){
        if(!ready[i].textContent) ready[i].textContent = T.settings;
        ready[i].addEventListener('click', function(e){ e.preventDefault(); openFrom(this); });
      }
      return;
    }
    var spans = document.querySelectorAll('footer .wrap > span');
    var target = spans[spans.length - 1];
    if(!target || target.querySelector('.consent-settings')) return;
    var link = document.createElement('a');
    link.href = PAGES.privacy + '#cookies';
    link.className = 'consent-settings';
    link.textContent = T.settings;
    link.addEventListener('click', function(e){ e.preventDefault(); openFrom(this); });
    target.appendChild(document.createTextNode(' · '));
    target.appendChild(link);
  }

  function start(){
    addFooterLink();
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
    var c = get();
    if(c !== 'granted' && c !== 'denied') show();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
